import DetailsPageTitle from "components/common/DetailsPageTitle";
import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import { MapPin } from "lucide-react";
import { GoogleMap, MarkerF, useJsApiLoader } from "@react-google-maps/api";
import { useDispatch, useSelector } from "react-redux";
import { getBranchDetails } from "store/actions/branchSlice";
import Spinners from "components/common/Spinners";

const containerStyle = {
  width: "100%",
  height: "400px",
  borderRadius: 20,
};

// Default map center position (latitude, longitude)

const BranchDetails = () => {
  const { t } = useTranslation();
  document.title = t("Branch Details | Work Space");

  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Use JsApiLoader from @react-google-maps/api to load Google Maps API
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyADIaQz6BiMxdC5nHOuGixS_S-3Z5PELis", // Your Google Maps API key
    libraries: ["places"],
  });

  const { loading, branchDetails } = useSelector((state) => state.Branches);
  const [center, setCenter] = useState({});

  useEffect(() => {
    const getDetails = () => {
      const payload = {
        id,
      };
      dispatch(getBranchDetails(payload));
    };
    getDetails();
  }, []);

  useEffect(() => {
    if (branchDetails) {
      const { latitude, longitude } = branchDetails || {};
      const updatedCenter = {
        lat: latitude, //24.7136,
        lng: longitude, //46.6753,
      };

      setCenter(updatedCenter);
    }
  }, [branchDetails]);

  if (!isLoaded) {
    return <Spinners />; // Show loading spinner until the Google Maps API is loaded
  }

  return (
    <React.Fragment>
      <div className="page-content common_details_page">
        {loading ? (
          <Spinners />
        ) : (
          <Container fluid>
            <Row>
              <DetailsPageTitle title={t("Branch Details")} />
            </Row>
            <div className="common_wrapper">
              <Row>
                <Col lg={7} className="images_section">
                  {branchDetails?.imageUrls?.length > 0 && (
                    <div className="d-flex gap-3">
                      <div className="left_section">
                        <img src={branchDetails?.imageUrls[0]} alt="" />
                      </div>
                      <div
                        className="right_section"
                        style={{
                          gridTemplateColumns:
                            branchDetails?.imageUrls?.length <= 3
                              ? "1fr"
                              : "repeat(2, 1fr)",
                        }}
                      >
                        {branchDetails?.imageUrls
                          ?.slice(1)
                          ?.map((image, index) => (
                            <img
                              key={index}
                              src={image}
                              alt={`Right Image ${index + 1}`}
                            />
                          ))}
                      </div>
                    </div>
                  )}
                  <h2 className="mt_20 fs_24 text_black">
                    {branchDetails?.name || "-"}, {branchDetails?.nameAr}
                  </h2>
                  <p className="fs_14 text_dark_gray mt_15">
                    <MapPin className="text_gray me-1" width={14} height={14} />
                    {branchDetails?.address || "-"}
                  </p>
                  <p className="fs_14 text_dark_gray mt_15">
                    {t("City")}: {branchDetails?.cityId?.name || "-"}
                  </p>
                  <div className="location">
                    <h2 className="fs_20 mt_20">{t("Location")}</h2>
                    <div className="mt_20">
                      <GoogleMap
                        mapContainerStyle={containerStyle}
                        center={center}
                        zoom={12} // Adjust zoom level
                      >
                        {/* Example Marker */}
                        <MarkerF position={center} />
                      </GoogleMap>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
            <Row>
              <div className="g_end mt_32 mb-2">
                <button
                  className="main_btn"
                  onClick={() => {
                    navigate(
                      `/management/branches/update-branch?id=${id}`
                    );
                  }}
                >
                  {t("Edit")}
                </button>
              </div>
            </Row>
          </Container>
        )}
      </div>
    </React.Fragment>
  );
};

export default BranchDetails;
